import React from "react";
import GoogleMapComponent from "../../Common/Components/GoogleMapComponent";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const ZonePicker = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handlePicker = (e) => {
    console.log(e);
    dispatch({ type: "setZone", payload: e.zone });
    dispatch({
      type: "setAddress",
      payload: { address: e.address, cords: e.cords },
    });
    navigate("/app");
  };
  return (
    <div className="container-fluid">
      <div
        className="row align-items-center flex-column"
        style={{ height: "80vh" }}
      >
        <h5 className="text-center my-4">Please select your order location!</h5>
        <div
          className="col-lg-6 col-md-8 col-12"
          style={{ height: "calc(80vh - 120px)" }}
        >
          <GoogleMapComponent handleSelect={handlePicker} />
        </div>
      </div>
    </div>
  );
};
